<template>
    <div>
        <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item label="订单状态：" class="query-form-item">
                <el-select v-model="query.status" placeholder="状态" style="width: 120px"  @change="change">
                    <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :height="tableHeight"
            :data="list"
            size="mini"
            stripe border style="width: 100%">
            <el-table-column
                label="订单号">
                <template slot-scope="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="金额">
                <template slot-scope="scope">
                    <span>{{ scope.row.amount }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="货币"
                align="center"
                width="140">
                <template slot-scope="scope">
                    <el-tag type="danger">人民币</el-tag>
                    <el-tag type="danger" v-if="scope.row.currency == 'CNY'">人民币</el-tag>
                    <el-tag v-if="scope.row.currency == 'USD'">美金</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="状态"
                width="100"
                align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status == 0">未处理</el-tag>
                    <el-tag type="success" v-if="scope.row.status == 1">已充值</el-tag>
                    <el-tag type="info" v-if="scope.row.status == 2">已取消</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="时间">
                <template slot-scope="scope">
                    <span>{{ scope.row.time }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                fixed="right"
                width="150">
                <template slot-scope="scope">
                    <el-popover placement="right" title trigger="click">
                        <div style="width:400px;">
                            <img
                                style="width:100%;"
                                :src="image"
                                alt
                            />
                        </div>
                        <el-button type="success" size="mini" slot="reference" @click.native="viewVoucher(scope.row.evidence_id)" :disabled="disabled">查看凭证图片</el-button>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            :page-size="query.limit"
            style="float: right;margin-top: 20px; margin-bottom: 22px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="query.total">
        </el-pagination>
    </div>
</template>

<script>
import * as api from "@/api/user/payorders";
export default {
    components: {},
    data() {
        return {
            tableHeight: null,
            list: [],
            query: {
                page: 1,
                limit: 20
            },
            disabled: false,
            loading: false,
            filter: {},
            image: "",
            roles: [
                {
                    id: "0",
                    name: "未处理"
                },
                {
                    id: "1",
                    name: "已充值"
                },
                {
                    id: "2",
                    name: "已取消"
                }
            ]
        };
    },
    methods: {
        getList() {
            let obj = this.query;
            obj.filter = this.filter;
            api.my_request_list(obj).then(res => {
                if (res.code === 0) {
                    this.list = res.data.list;
                    this.query.page = res.data.page;
                    this.query.total = res.data.total;
                    this.query.total_page = res.data.total_page;
                } else {
                    this.$message({
                        type: "error",
                        message: res.message
                    });
                }
            });
        },
        //筛选
        change(val) {
            this.query.page = 1;
            this.filter.status = val;
            this.getList();
        },
        //查看凭证
        viewVoucher(data) {
            this.image = "";
            this.disabled = true;
            api.evidence_image({ id: data })
                .then(res => {
                    this.disabled = false;
                    if (res.code === 0) {
                        this.image = res.data.img;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        }
    },
    created() {
        this.getList();
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 165 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        164 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
